import gql from 'graphql-tag';

export default gql`
  query allSchoolsBackpackBuddy($districtId: ID = null, $schoolType: String = null) {
    allSchools(districtId: $districtId, schoolType: $schoolType) {
      id
      schoolId
      name
      address1
      address2
      city
      state
      zip
      county
      districtId
      type
      gradesServed
      applicationsBackpackBuddy {
        createdAt
        submittedAt
        status
        isContinuation
        submittedBy
        term {
          id
          type
          year
        }
      }
      teamMembersBackpackBuddy {
        teamMemberId
        firstName
        lastName
        title
        phone
        email
        type
      }
    }
  }
`;
